import axios from 'axios';

import { API_URL, API_POSTFIX_V1 } from '@services/api.service';

import JWTService from './jwt.service';

export default {
  async checkUserAuth() {
    try {
      await axios.get(`${API_URL}${API_POSTFIX_V1}account/validate`, {
        headers: {
          Authorization: `bearer ${JWTService.getToken()}`,
        },
      });
      return Promise.resolve();
    } catch (e) {
      JWTService.removeToken();
      return Promise.reject(e);
    }
  },
};
